<router-outlet></router-outlet>

<!-- Container utilizzato per la generazione dinamica del componente pdf -->
<div #pdfContainer style="display: none"></div>
